











































import { BFormCheckbox, BFormGroup, BFormInput } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { useCustomersStore } from "@/store/useCustomersStore";

export default {
    components: { BFormGroup, BFormCheckbox, BFormInput },
    setup() {
        const { customerSettings, editableCustomerSettings } = storeToRefs(useCustomersStore());

        editableCustomerSettings.value.push("engageUniqueContactsLimit", "engageMessagesLimit");

        return {
            customerSettings,
        };
    },
};
